import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { deserializeDate } from './helpers';
import { getDateComponentWUT } from './date-components-wut';
import { getDateFormatParts, isSupportedDatePart } from '../../utils/date-format-parts';
import { useConfig } from '../../contexts/config-context';
export function DatePickerWUT(_ref) {
  let {
    value,
    ...rest
  } = _ref;
  const {
    regionalFormat
  } = useConfig();
  const dateFormat = getDateFormatParts(regionalFormat).filter(isSupportedDatePart);
  const dateFormatPartsStr = dateFormat.join(',');
  const DateComponents = useMemo(() => dateFormatPartsStr.split(',').map(part =>
  // Can be removed after migration
  getDateComponentWUT(part.toUpperCase())), [dateFormatPartsStr]);
  const values = useMemo(() => deserializeDate(value), [value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, DateComponents.map((DateComponent, index) => /*#__PURE__*/React.createElement(DateComponent, _extends({
    key: index,
    values: values
  }, rest))));
}
//# sourceMappingURL=date-picker-wut.js.map